import { UseQueryOptions } from '@tanstack/react-query';

import { DisplayTemplate } from '@crossnokaye/typescript-sdk/models/components';

import { equipmentBrowserGetEquipmentBulkEditView } from '@repo/sdk/funcs/equipmentBrowserGetEquipmentBulkEditView';
import { BulkEditView } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { PreviewEquipmentBulkEditViewRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { displayTemplateSourceKey } from '@/queries/gaia-api/display-template-source-key';
import { GaiaQueryWithAgentId } from '@/queries/types';
import { hashValue } from '@/utils/hash';

interface PreviewEquipmentBulkEditViewQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  deviceKind?: string;
  deviceIds?: string[];
  displayTemplate: DisplayTemplate;
}

export const previewEquipmentBulkEditViewQuery = ({
  agentId,
  client,
  deviceIds,
  deviceKind,
  displayTemplate,
}: PreviewEquipmentBulkEditViewQueryProps): UseQueryOptions<
  BulkEditView,
  SDKError,
  BulkEditView | undefined
> => {
  const templateHash = hashValue(displayTemplate);
  return {
    enabled: !!agentId && !!deviceKind,
    queryKey: [
      agentId,
      'previewEquipmentBulkEditView',
      deviceKind,
      deviceIds,
      templateHash,
      displayTemplateSourceKey(client),
    ],
    queryFn: () =>
      client<PreviewEquipmentBulkEditViewRequest, BulkEditView>({
        gaiaFunc: equipmentBrowserGetEquipmentBulkEditView,
        request: {
          agentId: agentId!,
          deviceKind: deviceKind!,
          deviceIds: deviceIds,
          body: {
            displayTemplate: JSON.stringify(displayTemplate),
          },
        },
      }),
    staleTime: Infinity,
  };
};
